import axios, { CancelTokenSource } from 'axios';
import { postWhenAuthorized } from './api';
import { IGroup } from '../store/group/groupState';

export const logEvent = async (event: string, elementId: string | null, elementName: string | null, group: IGroup | null, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/event`,
    {
        'haendelse': event,
        'elementIdStreng': elementId,
        'elementNavn': elementName,
        'service': 'dinet',
        'diNrVirksomhed': group && group.companyId,
        'gruppeId': group && group.id,
        'gruppeNavn': group && group.name
    }, cancelTokenSource);

export async function error(errorMessage: Error | null, info: object, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) {
    // return await axios.post(`/api/log/error`, {
    //  error: errorMessage != null ? errorMessage.toString() : '',
    //  info: info != null ? JSON.stringify(info) : ''
    // }, {
    //    cancelToken: cancelTokenSource.token
    //  })
    //  .catch(() => {
    //    // Intentionally left unhandled
    //  });
    // TEMP
}